export const FETCH_ASSETAUM_BEGIN = "FETCH_ASSETAUM_BEGIN";
export const FETCH_ASSETAUM_SUCCESS = "FETCH_ASSETAUM_SUCCESS";
export const FETCH_ASSETAUM_FAILURE = "FETCH_ASSETAUM_FAILURE";

   